import i18next from 'i18next'
import {CHATBOT_SOURCES} from '../../types'
import {useChatbotStore} from '../../store/chatbotStore'
import {CancelShoot} from '../../components/cancel-shoot.tsx'

const confirmReassignShoot = (isInShootPage: boolean) => [
    {
        id: 'host_confirm_reassign_shoot_options_ask',
        message: () => {
            const cancellationReason = useChatbotStore.getState().cancellationReason
            return i18next.t('chatbot:commons:confirm_reason', {
                cancellationReason: cancellationReason?.text || ''
            })
        },
        trigger: () => {
            const cancellationReason = useChatbotStore.getState().cancellationReason

            useChatbotStore.getState().addStepToHistory({
                id: 'MB1.host_confirm_reassign_shoot_options_ask',
                source: CHATBOT_SOURCES.CHATBOT,
                text: `Please confirm you want to cancel this shoot because of "${cancellationReason?.text || ''}"`
            })
            return 'host_confirm_reassign_shoot_options'
        }
    },
    {
        id: 'host_confirm_reassign_shoot_options',
        options: [
            {
                value: 'confirm',
                label: i18next.t('chatbot:commons:confirm_cancellation'),
                trigger: () => {
                    useChatbotStore.getState().addStepToHistory({
                        id: 'host_confirm_reassign_shoot_options',
                        source: CHATBOT_SOURCES.USER,
                        text: 'Confirm cancellation'
                    })
                    return 'host_confirm_reassign_shoot_confirmed'
                }
            },
            {
                value: 'abandon',
                label: i18next.t('chatbot:commons:changed_mind'),
                trigger: () => {
                    useChatbotStore.getState().addStepToHistory({
                        id: 'host_confirm_reassign_shoot_options',
                        source: CHATBOT_SOURCES.USER,
                        text: "I've changed my mind"
                    })
                    return isInShootPage ? '3' : 'start_generic'
                }
            }
        ]
    },
    {
        id: 'host_confirm_reassign_shoot_confirmed',
        component: <CancelShoot flowSource="MB1.4_reassign" cancelBy="creator" />,
        asMessage: true,
        replace: true,
        trigger: 'host_confirm_reassign_shoot_confirmed_sent'
    },
    {
        id: 'host_confirm_reassign_shoot_confirmed_sent',
        message: i18next.t('chatbot:mb14:mb1.4_cancel_sent'),
        trigger: () => {
            useChatbotStore.getState().addStepToHistory({
                id: 'host_confirm_reassign_shoot_confirmed_sent',
                source: CHATBOT_SOURCES.CHATBOT,
                text: 'Thank you for letting us know the reason of the cancellation. We can confirm the photoshoot request has been canceled.'
            })
            return 'send_log'
        }
    }
]

export const reassign = (isInShootPage: boolean) => [
    {
        id: 'MB1.4_reassign',
        options: [
            {
                value: 'matching_availabilities',
                label: i18next.t('chatbot:mb14:mb1.4_reassign1'),
                trigger: () => {
                    useChatbotStore.getState().setCancellationReason({
                        text: i18next.t('chatbot:mb14:mb1.4_reassign1'),
                        id: 'creator_dont_matching_availabilities'
                    })
                    useChatbotStore.getState().addStepToHistory({
                        id: 'MB1.4_reassign',
                        source: CHATBOT_SOURCES.USER,
                        text: "We don't have matching availabilities"
                    })
                    return 'host_confirm_reassign_shoot_options_ask'
                }
            },
            {
                value: 'not_available',
                label: i18next.t('chatbot:mb14:mb1.4_reassign2'),
                trigger: () => {
                    useChatbotStore.getState().setCancellationReason({
                        text: i18next.t('chatbot:mb14:mb1.4_reassign2'),
                        id: 'creator_not_available_anymore'
                    })
                    useChatbotStore.getState().addStepToHistory({
                        id: 'MB1.4_reassign',
                        source: CHATBOT_SOURCES.USER,
                        text: 'I am not available anymore'
                    })
                    return 'host_confirm_reassign_shoot_options_ask'
                }
            },
            {
                value: 'too_far',
                label: i18next.t('chatbot:mb14:mb1.4_reassign3'),
                trigger: () => {
                    useChatbotStore.getState().setCancellationReason({
                        text: i18next.t('chatbot:mb14:mb1.4_reassign3'),
                        id: 'creator_located_far_away'
                    })
                    useChatbotStore.getState().addStepToHistory({
                        id: 'MB1.4_reassign',
                        source: CHATBOT_SOURCES.USER,
                        text: 'The listing is located too far away'
                    })
                    return 'host_confirm_reassign_shoot_options_ask'
                }
            },
            {
                value: 'not_comfortable',
                label: i18next.t('chatbot:mb14:mb1.4_reassign4'),
                trigger: () => {
                    useChatbotStore.getState().setCancellationReason({
                        text: i18next.t('chatbot:mb14:mb1.4_reassign4'),
                        id: 'creator_dont_feel_comfortable'
                    })
                    useChatbotStore.getState().addStepToHistory({
                        id: 'MB1.4_reassign',
                        source: CHATBOT_SOURCES.USER,
                        text: "I don't feel comfortable shooting this property"
                    })
                    return 'host_confirm_reassign_shoot_options_ask'
                }
            },
            {
                value: 'mistake',
                label: i18next.t('chatbot:mb14:mb1.4_reassign5'),
                trigger: () => {
                    useChatbotStore.getState().setCancellationReason({
                        text: i18next.t('chatbot:mb14:mb1.4_reassign5'),
                        id: 'creator_accepted_mistake'
                    })
                    useChatbotStore.getState().addStepToHistory({
                        id: 'MB1.4_reassign',
                        source: CHATBOT_SOURCES.USER,
                        text: 'I accepted the shoot by mistake'
                    })
                    return 'host_confirm_reassign_shoot_options_ask'
                }
            },
            {
                value: 'reschedule_3_times',
                label: i18next.t('chatbot:mb14:mb1.4_reassign6'),
                trigger: () => {
                    useChatbotStore.getState().setCancellationReason({
                        text: i18next.t('chatbot:mb14:mb1.4_reassign6'),
                        id: 'host_rescheduled_3_times'
                    })
                    useChatbotStore.getState().addStepToHistory({
                        id: 'MB1.4_reassign',
                        source: CHATBOT_SOURCES.USER,
                        text: 'Host rescheduled more than 3 times'
                    })
                    return 'host_confirm_reassign_shoot_options_ask'
                }
            },
            {
                value: 'other',
                label: i18next.t('chatbot:cancellation_reasons:other_issues'),
                trigger: () => {
                    useChatbotStore.getState().addStepToHistory({
                        id: 'MB1.4_host_cancel',
                        source: CHATBOT_SOURCES.USER,
                        text: 'Other issues'
                    })
                    return 'MB1.4_options'
                }
            }
        ]
    },
    ...confirmReassignShoot(isInShootPage)
]
